export const sanitizeRichText = (html: string): string =>
  html
    // keep only br, strong, ul, li
    .replace(/<(?!\/?(br|strong|ul|li)\b)([^>])+>/gi, '') // strip p
    .replace(/<\/?p[^>]*>/gi, ''); // or this line alone
